<template>
  <div class="camsContainer">
    <div class="nonGraphContainer">
      <div class="pageHeader">
        <ContentHeader :name=this.headerName :subHeader="subHeader" :route="subPage" />
        <button @click="(event) => handleButtonPress(event)">New User</button>
      </div>
      <!-- <Insights :cardInfo="cardInfo" :callback="updateFiltersForSearchBasedOnCard" /> -->
    </div>

    <UsersModal />

    <div class="currentView">
      <!-- These selectors should probably be their own component -->
      <div>
        <div class="dataTableSelectorGroup">
          <div class="dataTableSelector" id="filtersModal">
            <SearchBar v-bind:search="search" v-bind:searchCallback="(data) => { this.performSearch(data) }">
            </SearchBar>
            <div class="iconGroup" @click="openGateFiletersModal">
              <svg class="filterIcon" width="32" height="26" viewBox="0 0 32 26" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <rect width="32" height="4" fill="#699991" rx="2" />
                <rect x="8" y="22" width="16" height="4" fill="#699991" rx="2" />
                <rect x="4" y="11" width="24" height="4" fill="#699991" rx="2" />
              </svg>
            </div>
          </div>
        </div>
        <DataTable v-bind:tableData="usersTableData" v-bind:configuration="users" v-bind:search="search"
          v-bind:openModalCallback="function () { handleModal(users); }" />

        <AnalyticsGraph title="At a Glance" v-bind:configuration="users" />
      </div>
    </div>
  </div>
</template>

<script>
import ContentHeader from "../../ContentHeader";
import * as Constants from "../../../js/constants";
import EventBus from "../../../eventBus";
import DataTable from "../pageComps/DataTable.vue";
import UsersModal from "../../modals/UsersModal.vue";
import SearchBar from "../pageComps/Search.vue";
import CTSRepository from "../../../js/CTSRepository";
// import Insights from "../../layout/Insights.vue";

export default {
  name: "UsersPage",
  props: ["subPage", "organizationData"],
  components: {
    ContentHeader,
    DataTable,
    UsersModal,
    SearchBar,
    // Insights
  },
  data() {
    return {
      subHeader: "Below is a list of all of the Users in your Community",
      selectedItem: Constants.GATE,
      headerName: Constants.USERS,
      filterStartDate: null,
      filterEndDate: null,
      defaultStartDate: null,
      defaultEndDate: null,
      filters: [],
      usersTableData: [],
      tableData: [],
      search: "",
      users: Constants.USERS,
      cardInfo: Constants.DEFAULT_CARD_INFO
    };
  },
  created() {
    this.changeView(this.selectedItem);
    EventBus.$on("keys", this.changeView);
    EventBus.$on("incidents", this.changeView);

    var date = new Date();
    this.defaultEndDate = date.toISOString().split('T')[0]
    var startDate = new Date(date)
    startDate.setDate(date.getDate() - 7);
    //this.defaultStartDate = startDate.toISOString().split('T')[0]
    this.defaultStartDate = "2019-06-06"


  },
  watch: {
    organizationData: function (newVal) {
      if (newVal != null) {

        this.performSearch("").then((apiData) => {
          console.log("Finished getting and setting API Data", apiData);
        });
      }
    }
  },

  mounted() {
     this.performSearch(this.search).then((apiData) => {
          console.log("Finished getting and setting API Data", apiData);
        });
  },
  methods: {
    openGateFiletersModal() {
      console.log("Opening Gate Filters Modal")
    },
    homeChangeText() {
      console.log("Home knows the button was clicked");
    },
    changeView(name) {
      console.log("Changing View from ", this.selectedItem, " to ", name);
      if (name == "keys") {
        this.showKeys = true;
        this.showIncidents = false;
        this.selectedItem = name;
      } else if (name == "incidents") {
        this.showIncidents = true;
        this.showKeys = false;
        this.selectedItem = name;
      }
    },
    getUsersData() {
      if (this.$props.organizationData == null) return
      return new CTSRepository(this.$props.organizationData).fetchResidents("")
        .then((data) => {
          console.log("Response Data", data);
          this.usersTableData = data.data;
        })
        .catch((err) => {
          console.log("Error fetching user data from directory", err)
        });
    },
    performSearch(data) {
      if (this.$props.organizationData == null) return
      this.search = data
      return new CTSRepository(this.$props.organizationData).fetchResidents(data)
        .then((data) => {
          console.log("Search Data", data);
          this.usersTableData = data.data
        })
        .catch((err) => {
          console.log("Error searching user data from directory", err)
        });
    },
    getDataFromAPI() {
      this.getUsersData()
    },
    openGateModal() {
      this.$modal.show("gate-modal");
    },
    openUsersModal() {
      this.$modal.show("users-modal");
    },
    handleModal(configuration) {
      switch (configuration) {
        case Constants.GATE: {
          this.openGateModal();
          break;
        }
        case Constants.INCIDENTS: {
          console.log("Opening Incidents Modal");
          break;
        }
        case Constants.USERS: {
          this.openUsersModal()
          break;
        }
      }
    },
    handleButtonPress() {
      this.$modal.show(Constants.CREATE_USERS_MODAL)
    }
  },
};
</script>

<style scoped>
.dataTableSelectorGroup {
  display: flex;
  widows: 100%;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 16px;
}

.dataTableSelector:nth-child(3n) {
  margin-right: 0px;
}

.selectorContent {
  width: 100%;
  color: white;
  font-size: 28px;
  display: inline;
  margin-right: 16px;
}

.selectorContent::placeholder {
  width: 100%;
  color: white;
  font-size: 28px;
}

.pageHeader button {
  background-color: #1890FFCC;
  color: white;
}

.filterIcon {
  margin-right: 16px;
  display: inline;

}

.iconGroup {
  display: inline;
}
</style>